import {createRequestDataSource} from '@ngneat/elf-requests';
import {selectCurrentPageEntities} from '@ngneat/elf-pagination';

import {clientsServicesStore} from '@store/clients/services/clients-services.store';

export const getClientsServicesDataSource = createRequestDataSource({
  store: clientsServicesStore,
  data$: () => clientsServicesStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getClientsServices',
  dataKey: 'clientsServices',
});